var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"clss":"question-script"}},[(_vm.mode=='editor')?_c('EditorListQuestion'):_c('Main')],1)}
var staticRenderFns = []

export { render, staticRenderFns }